module.exports = __webpack_public_path__ + "static/media/cover-home-4.d1e12a66.jpg";